import Vue from 'vue';
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

const messages = {
    en:{
        name : "Full Name",
        nickname : "Nickname",
        birthdate : "Birthdate",
        email : "Email",
        tel : "Phone",
        skill : "Skills",
        days : 'Day',
        hours : 'Hour',
        months : "Months",
        minutes : "Min",
        seconds : "Sec",
        showMore : "Show More...",
        showLess : "Show Less...",
        education : "Education",
        exp : "Work Exp",
        yearExp : "{year} year | {year} years",
        monthExp : "{month} month | {month} months"
    },
    th:{
        name : "ชื่อ",
        nickname : "ชื่อเล่น",
        birthdate : "วันเกิด",
        email : "อีเมล",
        tel : "เบอร์",
        skill : "ทักษะ",
        days : 'วัน',
        hours : 'ชั่วโมง',
        months : "เดือน",
        minutes : "นาที",
        seconds : "วินาที",
        showMore : "แสดงเพิ่มเติม...",
        showLess : "แสดงน้อยลง...",
        education : "การศึกษา",
        exp : "ประสบการณ์",
        yearExp : "{year} ปี",
        monthExp : "{month} เดือน"
    }
}

export default new VueI18n({
    locale : 'en',
    messages
})


// WEBPACK FOOTER //
// ./src/i18n.js